import { render, staticRenderFns } from "./user-connection-request-list.html?vue&type=template&id=14239c59&scoped=true&"
import script from "./user-connection-request-list.js?vue&type=script&lang=js&"
export * from "./user-connection-request-list.js?vue&type=script&lang=js&"
import style0 from "./user-connection-request-list.scss?vue&type=style&index=0&id=14239c59&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14239c59",
  null
  
)

export default component.exports